const modalOpen = (btnSelector, requestLink, ajaxJs = false) => {
	const btn = document.querySelector(btnSelector);
	let modalHtml, modalBlock,
		bodyBlock = document.querySelector('.body');
	
	try {
		btn.addEventListener('click', ()=>{

			// ширина скролла
	     	let divWidth = document.createElement('div'),
		    	scrollWidth;

			divWidth.style.overflowY = 'scroll';
			divWidth.style.width = '50px';
			divWidth.style.height = '50px';

			bodyBlock.appendChild(divWidth);
			scrollWidth = divWidth.offsetWidth - divWidth.clientWidth;

			bodyBlock.removeChild(divWidth);
		    //END ширина скролла

			// запрос

			if (ajaxJs) {

				let lintResult;
				console.log(btn.dataset.id)
				console.log(btn.dataset.quantity)

				if(requestLink == false && btn.dataset.id && btn.dataset.quantity) {
					lintResult = `/local/templates/schmetz/ajax/quickorder_form.php?ID=${btn.dataset.id}&QUANTITY=${btn.dataset.quantity}`;
				} else if(requestLink && btn.dataset.id && !btn.dataset.quantity) {
					lintResult = requestLink + btn.dataset.id;
				} else {
					lintResult = requestLink;
				}

				// console.log(lintResult)

				// BX.ajax({
				//    method: 'GET',
				//    dataType: 'html',
				//    url: lintResult,
				//    processData: false,
				//    onsuccess: function (result) {
				//    		let div = document.createElement('div');

				// 		div.classList.add('modal-block');
				// 		bodyBlock.style.overflow = 'hidden';
				// 		bodyBlock.style.marginRight = scrollWidth + 'px';

				// 		bodyBlock.appendChild(div);
				// 		let modalBlock = document.querySelector('.modal-block');

				//        	modalBlock.innerHTML = result;

				//        	eventModal();
				//    }
				// });

				let div = document.createElement('div');

				div.classList.add('modal-block');

				let idNumber = Math.floor(Math.random() * 10);

				div.id = `modal-id-${idNumber}`;
				bodyBlock.style.overflow = 'hidden';
				bodyBlock.style.marginRight = scrollWidth + 'px';

				bodyBlock.appendChild(div);
				// let modalBlock = document.querySelector('.modal-block');

				// modalBlock.innerHTML
				BX.ajax.insertToNode(
					lintResult,
					div.id
				);

				eventModal();

			} else {
				const sendRequest = new XMLHttpRequest();
				sendRequest.open('GET', requestLink, false);
				sendRequest.send();

				if (sendRequest.status != 200) {
				  // обработать ошибку
				  console.log( sendRequest.status + ': ' + sendRequest.statusText ); 
				} else {
				  // вывести результат
				  modalHtml = sendRequest.responseText;
				  // modalHtml = sendRequest.response;
				}

				let div = document.createElement('div');

				div.classList.add('modal-block');
				bodyBlock.style.overflow = 'hidden';
				 bodyBlock.style.marginRight = scrollWidth + 'px';

				bodyBlock.appendChild(div);
				let modalBlock = document.querySelector('.modal-block');

				modalBlock.innerHTML = modalHtml;

				// console.log('nooo')

				eventModal();
			}

			
			addEventListener('keydown', closeEsc);

			// событие на контейнере
			
			function eventModal () {
				let div = document.querySelector('.modal-block');
				
				// div.addEventListener('click', (e)=>{
				div.addEventListener('mousedown', (e)=>{
					let target = e.target;

					// закрываем окно
					if(target.classList.contains('close-modal') || target.classList.contains('modal-wrap')) {
						let modalWindow = document.querySelector('.modal-block');

						bodyBlock.removeChild(modalWindow);
						removeEventListener('keydown', closeEsc);
						// bodyBlock.style.overflow = 'auto';
						// bodyBlock.style.marginRight = '0px';
						bodyBlock.setAttribute("style", "overflow: auto; margin-right: 0px");
						// console.log(target)
					}

					// переключаем между "вход" и "регистрация"
					if(target.classList.contains('modal-title') && target.classList.contains('enter')) {
						target.classList.add('active');
						target.parentNode.querySelector('.registration').classList.remove('active');
						target.closest('.modal').querySelector('.modal-content').classList.remove('registration');
					} else if (target.classList.contains('modal-title') && target.classList.contains('registration')) {
						target.classList.add('active');
						target.parentNode.querySelector('.enter').classList.remove('active');
						target.closest('.modal').querySelector('.modal-content').classList.add('registration');
					}

					// кнопка восстановления пароля
					if(target.classList.contains('forget-pass-btn')) {
						let recoverPassHtml;


						document.querySelector('.modal-block .modal-wrap').remove();

						const sendRequestRecoverPass = new XMLHttpRequest();
						// sendRequestRecoverPass.open('GET', '../modals/recovery-pass.html', false);

						let urlTxt = target.dataset.url;
						sendRequestRecoverPass.open('GET', `${urlTxt}`, false);
						sendRequestRecoverPass.send();
						if (sendRequestRecoverPass.status != 200) {
						  // обработать ошибку
						  console.log( sendRequestRecoverPass.status + ': ' + sendRequestRecoverPass.statusText ); 
						} else {
						  // вывести результат
						  recoverPassHtml = sendRequestRecoverPass.responseText;
						  // recoverPassHtml = sendRequestRecoverPass.response;
						}

						let modalBlock = document.querySelector('.modal-block');



						modalBlock.innerHTML = recoverPassHtml;

						// обрабатываем скрипты

						let scriptJson = modalBlock.querySelectorAll('script');

						if(scriptJson[0]) {
							scriptJson.forEach(item =>{
								eval(item.innerHTML);
							});
						}

						//END обрабатываем скрипты

					}

			 	});
		 	}
		});
	} catch(e){}
	// закрыть окно на esc
	function closeEsc(e) {
		if(e.keyCode === 27) {
			let modalBlock = document.querySelector('.modal-block');
			bodyBlock.removeChild(modalBlock);
			removeEventListener('keydown', closeEsc);
			// bodyBlock.style.overflow = 'auto';
			// bodyBlock.style.marginRight = '0px';
			bodyBlock.setAttribute("style", "overflow: auto; margin-right: 0px");
		}
	}

}

export default modalOpen;